import { Component, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { PACT, SACT, LACT } from './config';
import { FitmentsContextualActionComponent } from './contextual-action.component';


@Component({
  moduleId: module.id,
  selector: 'research-action',
  templateUrl: 'research-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class ResearchActionComponent extends FitmentsContextualActionComponent {

  @HostBinding('class.research-action')
  hostClass: boolean = true;

  primaryActions = {
    'ASSIGN_TO_PRODUCT': PACT.ASSIGN_TO_PRODUCT,
  };
}
